// extracted by mini-css-extract-plugin
module.exports = {"anticon":"UYqY99vf","anticon-spin":"xdI3_XYD","loadingCircle":"x5lZbo5E"};